import { useEffect, useState } from "react";
import { api, type DirectoryUser } from "./api";

let cache: DirectoryUser[] | null = null;
let inFlight: Promise<DirectoryUser[]> | null = null;

async function fetchUsers(): Promise<DirectoryUser[]> {
  if (cache) return cache;
  if (inFlight) return inFlight;
  inFlight = api<{ users: DirectoryUser[] }>("/users").then((r) => {
    cache = r.users;
    inFlight = null;
    return r.users;
  });
  return inFlight;
}

export function invalidateUsers() {
  cache = null;
}

export function useUsers() {
  const [users, setUsers] = useState<DirectoryUser[]>(cache || []);
  useEffect(() => {
    fetchUsers().then(setUsers).catch(() => setUsers([]));
  }, []);
  return users;
}
